// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_ax-2";
export var aiChatCartContainerExit = "_ax-4";
export var aiChatContainerLarge = "_ax-0";
export var aiChatContainerSmall = "_ax-1";
export var aiChatIcon = "_ax-6";
export var slideInFromRight = "_ax-3";
export var slideOutToRight = "_ax-5";